import { Platform as RNPlatform } from 'react-native';
import DeviceInfo from 'react-native-device-info';

import { detectWebTV } from './tv/detectWebTV';

type PlatformProps = RNPlatform & {
  isAndroidTV: boolean;
  isWebTV: boolean;
  isFireTV: boolean;
  isVegaOS: boolean;
  isMobileWeb: (data?: 'ios' | 'android') => boolean;
  isSafari: boolean;
  isTV?: boolean;
  isSimulatedTV?: boolean;
  TVVendor?: string | null;
  TVOSName?: string | null;
};

const userAgent = navigator.userAgent;
const vendor = navigator.vendor;

const isChromeIOS = /GSA/i.test(userAgent);
const isEdge = /Edg/i.test(userAgent);
const isFirefoxIOS = /FxiOS/i.test(userAgent);

const isFireTV = () => {
  const brand = DeviceInfo.getBrand();
  const model = DeviceInfo.getModel();
  return brand === 'Amazon' && model.includes('AFT');
};

const Platform: PlatformProps = {
  ...RNPlatform,
  isAndroidTV: RNPlatform.isTV && RNPlatform.OS == 'android',
  isWebTV: false,
  isFireTV: isFireTV(),
  isVegaOS: false,
  isSafari:
    !isChromeIOS && !isEdge && !isFirefoxIOS && /Safari/i.test(userAgent) && /Apple/i.test(vendor),
  isMobileWeb: (data) => {
    if (RNPlatform.OS !== 'web') {
      return false;
    }

    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const iosWeb = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const androidWeb = /android/i.test(ua);

    switch (data) {
      case 'ios':
        return iosWeb;
      case 'android':
        return androidWeb;
      default:
        return iosWeb || androidWeb;
    }
  },
};

if (RNPlatform.OS === 'web') {
  const tv = detectWebTV();

  Platform.isTV = tv.isTV;
  Platform.isWebTV = tv.isTV;
  Platform.isSimulatedTV = tv.simulated;
  Platform.TVVendor = tv.simulated ? vendor : tv.vendor;
  Platform.TVOSName = tv.osName;
  Platform.isVegaOS = tv.osName === 'Vega OS';
}

export { Platform };
